import { render, staticRenderFns } from "./PostingOptions.vue?vue&type=template&id=89470fd6&scoped=true"
import script from "./PostingOptions.vue?vue&type=script&lang=ts"
export * from "./PostingOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89470fd6",
  null
  
)

export default component.exports